/**
 * Offsite app — /apps/offsite/*
 *
 * One job: an organizer wants the offsite to end with decisions, not vibes.
 * Three screens (C Mode): the Agenda (topics collected beforehand), the Room
 * (run it — present mode on the screen, everyone's phone in their hand), and
 * the Record (what was decided, what was parked, who owns what).
 *
 * Deliberately wraps a PRE-DESIGNED event: the B-Mode event designer stays in
 * the full platform (Doc 25 §4). This app never exposes it — an organizer picks
 * topics and runs the room; it does not become a second designer.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import AgendaScreen from './AgendaScreen';
import RecordScreen from './RecordScreen';

export default function OffsiteApp() {
  const app = getAppDefinition('offsite')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<AgendaScreen />} />
        <Route path=":sessionId" element={<RecordScreen />} />
        <Route path="*" element={<Navigate to="/apps/offsite" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
